import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReplaySubject, of } from 'rxjs';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { User } from 'src/typings';
import { ReceivingQueueService } from './receiving-queue.service';

@Component({
  selector: 'app-receiving-queue-shortcut',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <a *ngIf="view$ | async as view" mat-stroked-button
       class="receivingQueue" [class.receivingQueue--pending]="(view.count || 0) > 0"
       routerLink="/docs/buy/reconciliation" routerLinkActive="receivingQueue--active"
       [matTooltip]="view.label" [attr.aria-label]="view.label">
      <mat-icon [matBadge]="view.badge" matBadgeColor="warn" matBadgeSize="small"
                aria-hidden="true">fact_check</mat-icon>
      <span class="cdk-visually-hidden" aria-live="polite">{{ view.label }}</span>
    </a>
  `,
  styles: [`
    :host { display: contents; }
    .receivingQueue {
      display: inline-flex; align-items: center; justify-content: center;
      flex: 0 0 46px; width: 46px; min-width: 46px; height: 46px; padding: 0;
      border-radius: 14px; color: #475569; background: #f8fafc; border-color: #cbd5e1;
    }
    .receivingQueue--pending { color: #92400e; background: #fff7ed; border-color: #fdba74; }
    .receivingQueue:hover, .receivingQueue--active { background: #ffedd5; border-color: #f59e0b; }
    .receivingQueue mat-icon { margin: 0; }
  `]
})
export class ReceivingQueueShortcutComponent {
  private readonly users = new ReplaySubject<User | undefined>(1);
  @Input() set user(value: User | undefined) { this.users.next(value); }

  readonly view$ = this.users.pipe(
    map((user) => {
      const allowed = user?.isActive !== false && user?.roles?.some((role) =>
        [role.description, role.normalize_description].some((value) =>
          ['user', 'admin'].includes(String(value || '').trim().toLowerCase())));
      return user && allowed ? { userId: user.id } : null;
    }),
    distinctUntilChanged((a, b) => a?.userId === b?.userId),
    switchMap((scope) => scope ? this.queue.watch().pipe(map((state) => ({
      ...state,
      badge: state.unavailable ? '?' : state.count === null ? '…' : state.count,
      label: `Неразобранные приёмки · Все склады: ${state.unavailable
        ? 'счётчик недоступен' : state.count === null ? 'загрузка' : state.count}`
    }))) : of(null))
  );

  constructor(private readonly queue: ReceivingQueueService) {}
}
